export const PHYSICAL_RISK_UPDATED_AT_SORT = {
  key: "updatedAt",
  asc: false
}
